import { AIMagic } from "@/assets";
import { useProfile } from "@/context/useProfileProps";
import React from "react";

type AiAttemptStripProps = {
  attemptLeft: number;
  modifier: "primary" | "secondary";
};

const AiAttemptStrip = ({ attemptLeft, modifier }: AiAttemptStripProps) => {
  const {
    translation: { profileSummary },
  } = useProfile();
  return attemptLeft < 2 ? (
    <p
      className={`bg-state-surface-error-subtle text-border-error flex items-center justify-center gap-1 p-1 text-center text-sm ${modifier === "primary" ? "translate-y-[10px] rounded-tl-[4px] rounded-tr-[4px] !pb-3" : "rounded-[4px]"} `}
    >
      {modifier === "secondary" && <AIMagic height={24} width={24} />}
      {attemptLeft === 0
        ? profileSummary.noAttempt
        : profileSummary.lastAttempt}
    </p>
  ) : null;
};

export default AiAttemptStrip;
